import React, { useState, useEffect, useMemo } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { getLoggers } from "../../redux/apiCalls/loggersCall/loggersCall";
import Activity from "../../components/Cards/LoggersCard/Activity";
import { parse } from "date-fns";
import { es } from "date-fns/locale";
import { FormattedMessage } from "react-intl";
import Pagination from "../../components/Pagination/Pagination";

const PAGE_SIZE = 20;

const UserActivity = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const user = useSelector((state) => state.user.currentUser);
  const loggers = useSelector((state) => state.loggers.loggers) || [];

  const [page, setPage] = useState(1);

  useEffect(() => {
    if (user?.accessToken) {
      getLoggers(dispatch, user.accessToken);
    }
  }, [dispatch, user?.accessToken]);

  // Parse seguro del string de fecha del logger: "dd/MM/yyyy, hh:mm:ss a"
  const parseDate = (dateString) => {
    try {
      return parse(dateString, "dd/MM/yyyy, hh:mm:ss a", new Date(), {
        locale: es,
      });
    } catch {
      return new Date(0); // fecha mínima para que quede al final al ordenar
    }
  };

  // Ordenar por fecha desc (más reciente primero)
  const sortedLoggers = useMemo(() => {
    return [...loggers].sort((a, b) => parseDate(b.date) - parseDate(a.date));
  }, [loggers]);

  // Cálculo de paginación (20 por página)
  const totalPages = Math.max(1, Math.ceil(sortedLoggers.length / PAGE_SIZE));
  const startIdx = (page - 1) * PAGE_SIZE;
  const endIdx = Math.min(startIdx + PAGE_SIZE, sortedLoggers.length);
  const currentItems = sortedLoggers.slice(startIdx, endIdx);

  // Si cambia la cantidad total (por ejemplo, al cargar), aseguramos página válida
  useEffect(() => {
    if (page > totalPages) setPage(1);
  }, [totalPages, page]);

  return (
    <>
      <div>
        <div className="cont-path">
          <p
            className="path path-cursor"
            onClick={() => navigate(`/admin/lists?show=users`)}
          >
            <FormattedMessage id="Lists" defaultMessage="Lists" /> {">"}
          </p>
          <p className="path">
            {" "}
            <FormattedMessage id="Users" defaultMessage="Usuarios" />
          </p>
        </div>

        <div className="data-table">
          <div className="contAddUsers">
            <p className="users">Actividad de usuarios</p>
          </div>
        <Pagination
          filteredItems={sortedLoggers}
          startIdx={startIdx}
          endIdx={endIdx}
          page={page}
          setPage={setPage}
          totalPages={totalPages}
        />
        </div>
        <table className="table table-bordered">
          <thead>
            <tr className="user-row">
              <th>Usuario</th>
              <th>Actividad</th>
              <th>Fecha y hora</th>
            </tr>
          </thead>
          <tbody>
            {currentItems.map((a) => (
              <Activity key={a.id} user={user} activity={a} />
            ))}
          </tbody>
        </table>
      </div>
    </>
  );
};

export default UserActivity;
